import Barcode from "../pages/barcode";

export default [{ path: "/barcode", component: Barcode, special: true }];
